import React, { useEffect, useState } from 'react';
import { Grid, Typography } from '@mui/material';
import { selectVersionSelections } from '../../../redux/selectors/orderPlacementSelectors';
import TitleVersionChip from '../../_common/TitleVersionChip';
import { TitleEntity } from '@/redux/slices/slice_types';
import styled from '@emotion/styled';
import { useAppSelector } from '@/redux/hooks';

type SortedVersions = {
  [seriesName: string]: TitleEntity[];
};

const OPSortedFlatVersions = () => {
  const [sortedVersions, setSortedVersions] = useState<SortedVersions>({});
  const selectedVersions = useAppSelector(selectVersionSelections) as TitleEntity[];

  useEffect(() => {
    const groupedByProgramId: SortedVersions = {};
    selectedVersions.forEach((version: TitleEntity) => {
      if (!groupedByProgramId[version.program_id]) {
        groupedByProgramId[version.program_id] = [version];
      } else {
        groupedByProgramId[version.program_id].push(version);
      }
    });
    setSortedVersions(groupedByProgramId);
    return () => setSortedVersions({});
  }, [selectedVersions.length]);

  return (
    <div>
      {Object.keys(sortedVersions).map((programId) => {
        const titleData = sortedVersions[programId];
        const seriesName = titleData[0].lineage_meta.series_name;
        const episodeName = titleData[0].lineage_meta.program_name;
        const seasonNumber = titleData[0].lineage_meta.season_sequence_order;
        const epNumber = titleData[0].lineage_meta.program_sequence_order;

        return (
          <ProgramGrid key={programId} container flexDirection="column" alignItems="flex-start">
            <Grid container alignItems="center" justifyContent="space-between" sx={{ mb: 1 }}>
              <Grid item>
                <Typography variant="h3" sx={{ fontSize: '1.33rem', mb: 0 }}>
                  {seriesName}
                </Typography>
                <Grid container alignItems="center" sx={{ mt: 0.5 }}>
                  {(seasonNumber || epNumber) && (
                    <Typography variant="caption" sx={{ pr: 0.5, fontSize: '1rem' }}>
                      {seasonNumber && `S${seasonNumber} `}
                      {epNumber && `E${isNaN(Number(epNumber)) ? epNumber : Number(epNumber)}`}:
                    </Typography>
                  )}
                  <Typography variant="body2">{episodeName}</Typography>
                </Grid>
              </Grid>
              <Typography variant="caption" sx={{ ml: 1 }}>
                Prog ID: {programId}
              </Typography>
            </Grid>
            <Grid container item sx={{ ml: -1 }}>
              {titleData.map((version) => (
                <TitleVersionChip key={version.id} version={version} withTooltip sx={{ minWidth: 75 }} />
              ))}
            </Grid>
          </ProgramGrid>
        );
      })}
    </div>
  );
};

export default OPSortedFlatVersions;

const ProgramGrid = styled(Grid)`
  background: ${({ theme }) => theme.palette.background.default};
  padding: ${({ theme }) => theme.spacing(3)};
  margin-top: ${({ theme }) => theme.spacing(2)};
  margin-bottom: ${({ theme }) => theme.spacing(1)};
  border-radius: ${({ theme }) => theme.shape.borderRadius}px;
  border: ${({ theme }) => (theme.palette.mode === 'light' ? '1px solid rgba(0, 0, 0, 0.05)' : 'none')};
`;
